import { Team } from '@driftt/api-types'
import useSWR from 'swr'

import { CustomerAPI } from 'api'

const fetcher = (url: string) =>
  CustomerAPI.get<Team[]>(`/teams`).then((res) => res.data)

export const useTeams = () => {
  const { data } = useSWR<Team[]>(`/teams`, fetcher)
  return data
}
